export default __webpack_public_path__ + "static/media/electric-oven.98ec0f56.svg";